import { Dot } from './styled';

export const DotSeparator = (): JSX.Element => <Dot>•</Dot>;
